import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

import { FormControl, FormControlLabel, FormGroup, Stack, Switch, Typography } from "@mui/material";

/**
 * A small question mark icon with a tooltip.
 * Optionally includes a switch (ON/OFF).
 *
 * Justified content:
 * - left: title, tooltip
 * - right: switch
 */
export default function CustomTooltip(props) {
    const { title, form, tooltip, icon = <HelpOutlineIcon />, switchValue, switchLabel, switchChange, switchDisabled = false } = props;

    return (
        <Stack direction="row" alignItems="center" justifyContent="space-between" width={"100%"}>
            <Stack direction="row" alignItems="center" width={"100%"}>
                {title && <Typography variant="h5">{title}</Typography>}

                {form ?? undefined}

                <Tooltip title={<div style={{ whiteSpace: "pre-line" }}>{tooltip}</div>} enterDelay={200} leaveDelay={200} enterTouchDelay={100} arrow placement="top">
                    <IconButton color="primary">{icon}</IconButton>
                </Tooltip>
            </Stack>

            {switchChange && (
                <FormControl variant="standard">
                    <FormGroup sx={{ alignContent: "center" }}>
                        <FormControlLabel
                            control={<Switch checked={switchValue} onChange={switchChange} color="primary" />}
                            label={switchLabel}
                            labelPlacement="start"
                            disabled={switchDisabled}
                        />
                    </FormGroup>
                </FormControl>
            )}
        </Stack>
    );
}
